import moment from "moment";

const TIMELINE_AREAS = {
  EXPLORATION: 0,
  JOB_SEARCH: 1,
  REMAINING: 2,
};
const newGetWidth = (startDate, endDate) => {
  const dayDiff = endDate.diff(startDate, 'days');
  const width = (7.2*(dayDiff/9));
  // console.log('sss dayDiff', dayDiff, width)
  return {width, dayDiff};
}

export function checkWhereItLies(dataArr, month, day) {
  const today = moment();
  const section = moment(`${today.year()}-${month+1}-${day+1}`, "YYYY-MM-DD");
  let index = 0;
  let status = false;
  let item = null;

  for (let dataIndex = 0; dataIndex < dataArr.length; dataIndex++) {
    item = dataArr[dataIndex];
    index = dataIndex;
    const start = item.phaseId ? moment(item.adjustedStart, "YYYY-MM-DD") : moment(item.startDate, "YYYY-MM-DD");
    const end = item.phaseId ? moment(item.adjustedEnd, "YYYY-MM-DD") : moment(item.endDate, "YYYY-MM-DD");

    const isInRange = section.isBetween(start, end, undefined, "[]");

    if (isInRange) {
      if(item.phaseId){
        status = true;
        break
      }
      else{
        status = false;
        continue
      }
    }
    else{
      status = false;
      continue
    }
  }

  return { status: status, dataIndex: index, item: item };
}

export function mergeOrSplitPhase(timelineData, data){
  console.log('sss updatedTimeline mergePhase', timelineData, data)
  
  const foundPhase = timelineData.find(item => item.phaseId === data.phaseId)
  const foundPhaseIndex = timelineData.findIndex(item => item.phaseId === data.phaseId)
  console.log("sss updatedTimeline mergePhase phase", foundPhase, foundPhaseIndex)
  
  timelineData = timelineData.map((item, index) => {

    if(index !== foundPhaseIndex && item.phaseTitle.toLowerCase() === timelineData[foundPhaseIndex].phaseTitle.toLowerCase() ){

      if( moment(item.startDate).isBetween(moment(timelineData[foundPhaseIndex].startDate), moment(timelineData[foundPhaseIndex].endDate)) && moment(item.endDate).isBetween(moment(timelineData[foundPhaseIndex].startDate), moment(timelineData[foundPhaseIndex].endDate)) ){
        console.log('sss updatedTimeline mergePhase 1', index)
        return null
      }
      else if( moment(item.endDate).isBetween(moment(timelineData[foundPhaseIndex].startDate), moment(timelineData[foundPhaseIndex].endDate)) || ( moment(timelineData[foundPhaseIndex].startDate).diff(moment(item.endDate), "days") >= 0 && moment(timelineData[foundPhaseIndex].startDate).diff(moment(item.endDate), "days") <= 1 ) ) {
        timelineData[foundPhaseIndex].startDate = item.startDate
        console.log('sss updatedTimeline mergePhase 2', index)
        return null
      }
      else if( moment(timelineData[foundPhaseIndex].endDate).isBetween(moment(item.startDate), moment(item.endDate)) || ( moment(item.startDate).diff(moment(timelineData[foundPhaseIndex].endDate), "days") >= 0 && moment(item.startDate).diff(moment(timelineData[foundPhaseIndex].endDate), "days") <= 1 ) ) {
        timelineData[foundPhaseIndex].endDate = item.endDate
        console.log('sss updatedTimeline mergePhase 3', index)
        return null
      }
      else{
        timelineData[foundPhaseIndex].startDate = item.startDate < timelineData[foundPhaseIndex].startDate ? item.startDate : timelineData[foundPhaseIndex].startDate
        timelineData[foundPhaseIndex].endDate = item.endDate > timelineData[foundPhaseIndex].endDate ? item.endDate : timelineData[foundPhaseIndex].endDate
        return null
      }
    }
    return item;

  }).filter(phase => phase !== null)

  return timelineData;
}

export function splitAndUpdateSTG(STG, timeline, oldPhaseName, newPhaseName){

  console.log('sss STG', STG, timeline, oldPhaseName, newPhaseName)
  let GoalSubTask = []
  let newGoalSubTask = []
  let GoalSubTaskLength = null;
  let conflict = false;
  const maxGoalIndex = Math.max(...STG.map(task => task.id));

  if( oldPhaseName !== null){
    
    STG = STG.map((goal, index) => {
  
      if( goal.step.toLowerCase() === oldPhaseName.toLowerCase() ){
  
        GoalSubTaskLength = goal.subTasks.length
  
        newGoalSubTask = goal.subTasks.filter(subGoal => {
          
          if (moment(subGoal.startdate).isBetween(moment(timeline.startDate), moment(timeline.endDate), null, '[]') && moment(subGoal.enddate).isBetween(moment(timeline.startDate), moment(timeline.endDate), null, '[]')) {
            console.log('sss STG subGoal not split', subGoal);
            return true; // Include in newGoalSubTask
          } else {
            GoalSubTask.push(subGoal);
            console.log('sss STG subGoal split', subGoal, GoalSubTask);
            return false; // Exclude from newGoalSubTask
          }
        });
        console.log('sss STG newGoalSubTask', newGoalSubTask, GoalSubTaskLength, GoalSubTask)
    
        if(newGoalSubTask?.length === GoalSubTaskLength){
          return {
            ...goal,
            step: newPhaseName,
            subTasks: newGoalSubTask
          }
        }
        else{
          return {
            ...goal,
            step: newPhaseName,
            subTasks: GoalSubTask
          }
        }
      }
      return goal
    }).filter(phase => phase !== null)
  
    if(newGoalSubTask.length < GoalSubTaskLength){
      STG.push({
        id: maxGoalIndex+1,
        step: newPhaseName,
        subTasks: newGoalSubTask
      })
    }
  }
  else{
    console.log('sss STG in else')

    STG = STG.map((goal, index) => {
      if(goal.step.toLowerCase() === timeline.phaseTitle.toLowerCase()) {
        
        // Add safety check
        if(goal.subTasks && goal.subTasks.length > 0) {
          let updatedSubTasks = [...goal.subTasks]; // Create a copy to work with

          const earliestStartDateIndex = goal.subTasks.reduce((minIndex, task, index) => 
            task.startdate < goal.subTasks[minIndex].startdate ? index : minIndex, 0
          );
          
          const highestEndDateIndex = goal.subTasks.reduce((maxIndex, task, index) => 
            task.enddate > goal.subTasks[maxIndex].enddate ? index : maxIndex, 0
          );
          
          console.log('sss STG in else', earliestStartDateIndex, highestEndDateIndex, goal.subTasks[earliestStartDateIndex].startdate, timeline.startDate, goal.subTasks[highestEndDateIndex].enddate, timeline.endDate);

          // Condition 1: Both dates need adjustment (both are within timeline bounds)
          if(goal.subTasks[earliestStartDateIndex].startdate > timeline.startDate && goal.subTasks[highestEndDateIndex].enddate < timeline.endDate) {
            console.log('sss STG in else both are small');
            
            updatedSubTasks = updatedSubTasks.map((subTask, subIndex) => {
              if(subIndex === earliestStartDateIndex) {
                return {
                  ...subTask,
                  startdate: timeline.startDate,
                };
              }
              if(subIndex === highestEndDateIndex) {
                return {
                  ...subTask,
                  enddate: timeline.endDate,
                };
              }
              return subTask;
            });
          }

          // Condition 2: Start date is too late
          if(goal.subTasks[earliestStartDateIndex].startdate > timeline.startDate) {
            console.log('sss STG in else start date is small');
            
            updatedSubTasks = updatedSubTasks.map((subTask, subIndex) => {
              if(subIndex === earliestStartDateIndex) {
                return {
                  ...subTask,
                  startdate: timeline.startDate,
                };
              }
              return subTask;
            });
          }

          // Condition 3: End date is too early
          if(goal.subTasks[highestEndDateIndex].enddate < timeline.endDate) {
            console.log('sss STG in else end date is big');
            
            updatedSubTasks = updatedSubTasks.map((subTask, subIndex) => {
              if(subIndex === highestEndDateIndex) {
                return {
                  ...subTask,
                  enddate: timeline.endDate,
                };
              }
              return subTask;
            });
          }

          // Condition 4: Start date is too early
          if(goal.subTasks[earliestStartDateIndex].startdate < timeline.startDate) {
            console.log('sss STG in else start date is big');

            if(goal.subTasks.length === 1) {
              console.log('sss STG in else start date is big 11');
              
              updatedSubTasks = updatedSubTasks.map((subGoal, subGoalIndex) => {
                if(earliestStartDateIndex === subGoalIndex) {
                  return {
                    ...subGoal,
                    startdate: timeline.startDate,
                    enddate: timeline.endDate,
                  }
                }
                return subGoal;
              });
            } else {
              updatedSubTasks = updatedSubTasks.map((subGoal, subGoalIndex) => {
                if(earliestStartDateIndex !== subGoalIndex) {
                  if(!moment(subGoal.startdate).isBetween(moment(timeline.startDate), moment(timeline.endDate), null, '[]') || !moment(subGoal.enddate).isBetween(moment(timeline.startDate), moment(timeline.endDate), null, '[]')) {
                    conflict = true;
                    console.log('sss STG in else start date is big 1', subGoal);
                  }
                } else {
                  if(!moment(subGoal.enddate).isBetween(moment(timeline.startDate), moment(timeline.endDate))) {
                    conflict = true;
                    console.log('sss STG in else start date is big 2', subGoal);
                  } else {
                    console.log('sss STG in else start date is big 21', subGoal);
                    return {
                      ...subGoal,
                      startdate: timeline.startDate,
                    }
                  }
                }
                return subGoal;
              });
            }
          }

          // Condition 5: End date is too late
          if(goal.subTasks[highestEndDateIndex].enddate > timeline.endDate) {
            console.log('sss STG in else end date is small');

            if(goal.subTasks.length === 1) {
              console.log('sss STG in else end date is small 11');
              
              updatedSubTasks = updatedSubTasks.map((subGoal, subGoalIndex) => {
                if(highestEndDateIndex === subGoalIndex) {
                  return {
                    ...subGoal,
                    startdate: timeline.startDate,
                    enddate: timeline.endDate,
                  }
                }
                return subGoal;
              });
            } else {
              updatedSubTasks = updatedSubTasks.map((subGoal, subGoalIndex) => {
                if(highestEndDateIndex !== subGoalIndex) {
                  if(!moment(subGoal.startdate).isBetween(moment(timeline.startDate), moment(timeline.endDate), null, '[]') || !moment(subGoal.enddate).isBetween(moment(timeline.startDate), moment(timeline.endDate), null, '[]')) {
                    conflict = true;
                    console.log('sss STG in else end date is small 1', subGoal);
                  }
                } else {
                  if(!moment(subGoal.startdate).isBetween(moment(timeline.startDate), moment(timeline.endDate))) {
                    conflict = true;
                    console.log('sss STG in else end date is small 2', subGoal);
                  } else {
                    console.log('sss STG in else end date is small 21', subGoal);
                    return {
                      ...subGoal,
                      enddate: timeline.endDate,
                    }
                  }
                }
                return subGoal;
              });
            }
          }

          if (updatedSubTasks.length === 1) {
            console.log('sss updatedSubTasks goal', goal, updatedSubTasks.length);
            
            updatedSubTasks = updatedSubTasks.map(subTask => ({
              ...subTask,
              goal: timeline.goalDescription,
            }));
          }

          // Return the goal with updated subTasks
          return {
            ...goal,
            subTasks: updatedSubTasks
          };
        }
      }
      return goal;
    });
  }

  console.log('sss STG updated', STG, conflict)
  
  // STG = STG.
  const stepMap = new Map();

  STG.forEach(item => {
    if (stepMap.has(item.step)) {
      // Merge subTasks if step already exists
      const existing = stepMap.get(item.step);
      existing.subTasks = [...existing.subTasks, ...item.subTasks];
    } else {
      // Add new step
      stepMap.set(item.step, { ...item });
    }
  });

  STG = Array.from(stepMap.values());


  return { STG, conflict }
}

const calculateWidth = (start, end, timelineStart) => {
  if (!start || !end || !start.isValid() || !end.isValid()) {
    return 0;
  }

  const totalMonths = 12;
  let totalFraction = 0;
  const fixedDaysInMonth = 30;

  for (let m = 0; m < totalMonths; m++) {
    const monthStart = timelineStart.clone().add(m, 'months').startOf('month');
    const monthEnd = monthStart.clone().add(fixedDaysInMonth - 1, 'days');

    if (end.isBefore(monthStart) || start.isAfter(monthEnd)) {
      continue;
    }

    if (start.isSameOrAfter(monthStart) && end.isSameOrBefore(monthEnd)) {
      const daysUsed = end.diff(start, 'days') + 1;
      totalFraction += daysUsed / fixedDaysInMonth;
    } else if (start.isSameOrAfter(monthStart) && start.isBefore(monthEnd)) {
      const daysUsed = monthEnd.diff(start, 'days') + 1;
      totalFraction += daysUsed / fixedDaysInMonth;
    } else if (end.isAfter(monthStart) && end.isSameOrBefore(monthEnd)) {
      const daysUsed = end.diff(monthStart, 'days') + 1;
      totalFraction += daysUsed / fixedDaysInMonth;
    } else {
      totalFraction += 1;
    }
  }

  return (totalFraction / totalMonths) * 100;
};



export function setTimelinePercentage(startDate, endDate, current, previous, next) {
  console.log('sss setTimelinePercentage', {startDate, endDate, current, previous, next})
  const timelineStart = moment().startOf('month');
  const totalMonths = 12;
  const fixedDaysInMonth = 30;

  if (!startDate.isValid() || !endDate.isValid()) {
    return { left: 0, width: 0 };
  }

  let totalFraction = 0;

  for (let m = 0; m < totalMonths; m++) {
    const monthStart = timelineStart.clone().add(m, 'months').startOf('month');
    const monthEnd = monthStart.clone().add(fixedDaysInMonth - 1, 'days');

    if (endDate.isBefore(monthStart) || startDate.isAfter(monthEnd)) {
      continue;
    }

    if (startDate.isSameOrAfter(monthStart) && endDate.isSameOrBefore(monthEnd)) {
      const daysUsed = endDate.diff(startDate, 'days') + 1;
      totalFraction += daysUsed / fixedDaysInMonth;
    } else if (startDate.isSameOrAfter(monthStart) && startDate.isBefore(monthEnd)) {
      const daysUsed = monthEnd.diff(startDate, 'days') + 1;
      totalFraction += daysUsed / fixedDaysInMonth;
    } else if (endDate.isAfter(monthStart) && endDate.isSameOrBefore(monthEnd)) {
      const daysUsed = endDate.diff(monthStart, 'days') + 1;
      totalFraction += daysUsed / fixedDaysInMonth;
    } else {
      // totalFraction += 1;
      if (startDate.isBefore(monthStart) && endDate.isAfter(monthEnd)) {
        totalFraction += 1;
      } else {
        // partial coverage
        const overlapStart = moment.max(startDate, monthStart);
        const overlapEnd = moment.min(endDate, monthEnd);
        const daysUsed = overlapEnd.diff(overlapStart, 'days') + 1;
        totalFraction += daysUsed / 30;
      }
    }
  }

  let width = (totalFraction / totalMonths) * 100;
  const dayDiff = endDate.diff(startDate, 'days');

  // Previous
  let previousWidth = 0, previousDayDiff = 0;
  if (previous) {
    const prevStart = moment(previous.adjustedStart || previous.startDate, "YYYY-MM-DD");
    const prevEnd = moment(previous.adjustedEnd || previous.endDate, "YYYY-MM-DD");
    previousWidth = calculateWidth(prevStart, prevEnd, timelineStart);
    previousDayDiff = prevEnd.diff(prevStart, 'days');
  }

  // Next
  let nextWidth = 0, nextDayDiff = 0;
  if (next) {
    const nextStart = moment(next.adjustedStart || next.startDate, "YYYY-MM-DD");
    const nextEnd = moment(next.adjustedEnd || next.endDate, "YYYY-MM-DD");
    nextWidth = calculateWidth(nextStart, nextEnd, timelineStart);
    nextDayDiff = nextEnd.diff(nextStart, 'days');
  }

  if (previousDayDiff < 7) width += previousWidth / 2;
  if (nextDayDiff < 7) width += nextWidth / 2;

  return { width, dayDiff, previousDayDiff, nextDayDiff, totalFraction };
}




const getWidth = (area, commitment) => {
  let width = 25;

  if (commitment > 0) {
    switch (area) {
      case TIMELINE_AREAS.EXPLORATION:
        width =
          commitment <= 5
            ? 31
            : commitment <= 10
            ? 22.222222
            : commitment <= 20
            ? 11.111111
            : 8.333333;
        break;
      case TIMELINE_AREAS.JOB_SEARCH:
        width = commitment <= 20 ? 44 : 33.333333;
        break;
      case TIMELINE_AREAS.REMAINING:
        width =
          100 -
          getWidth(TIMELINE_AREAS.EXPLORATION, commitment) -
          getWidth(TIMELINE_AREAS.JOB_SEARCH, commitment);
        break;
      default:
        break;
    }
  }

  return width;
};

function getColSpan() {}

//will use object to get months using modulo
const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const getMonths = (joinedOn) => {
  let m = [];
  let joined = joinedOn.month() + 1;
  if (joined < 2) {
    m = [months[months.length - 1], ...months.slice(joined - 1, joined + 6)];
  } else if (joined < 6) {
    m = months.slice(joined - 2, joined + 7);
  } else {
    m = months.slice(joined - 2);
    m = [...m, ...months.slice(0, 9 - m.length)];
  }

  return m;
};

const getMonthsWithYears = (date) => {
  const year = date.year();
  return months.map((month) => ({ month, year }));
};

const getMonthsWithYearsFromCurrent = (date) => {
  const result = [];
  let monthIndex = date.month(); // 0-based (0 = Jan)
  let year = date.year();

  for (let i = 0; i < 12; i++) {
    result.push({
      month: months[monthIndex],
      year: year
    });

    monthIndex++;
    if (monthIndex === 12) {
      monthIndex = 0;
      year++;
    }
  }

  return result;
};

// const getMonthsWithYears = (date) => {
//   let result = [];
//   const currentMonth = date.month() + 1;
//   const currentYear = date.year();
  
//   const formatMonthYear = (month, year) => {
//     return {month: months[(month + 12) % 12], year: year};
//   };

//   let startMonth = currentMonth - 1;
//   let startYear = currentYear;
  
//   if (startMonth <= 0) {
//     startMonth += 12;
//     startYear--;
//   }

//   for (let i = 0; i < 12; i++) {
//     let month = startMonth + i;
//     let year = startYear;
    
//     if (month > 12) {
//       month -= 12;
//       year++;
//     }
    
//     result.push(formatMonthYear(month - 1, year));
//   }

//   return result;
// };


const monthsBeforeToday = (month, joinedOn) => {
  return getMonths(joinedOn).indexOf(months[month]) >= 0 ? getMonths(joinedOn).indexOf(months[month]) : 1;
};

export { TIMELINE_AREAS, getWidth, newGetWidth, getColSpan, getMonths, getMonthsWithYears, getMonthsWithYearsFromCurrent, monthsBeforeToday };


// const TIMELINE_AREAS = {
//   EXPLORATION: 0,
//   JOB_SEARCH: 1,
//   REMAINING: 2,
// };

// const getWidth = (area, commitment) => {
//   let width = 25;

//   if (commitment > 0) {
//     switch (area) {
//       case TIMELINE_AREAS.EXPLORATION:
//         width =
//           commitment <= 5
//             ? 31
//             : commitment <= 10
//             ? 22.222222
//             : commitment <= 20
//             ? 11.111111
//             : 8.333333;
//         break;
//       case TIMELINE_AREAS.JOB_SEARCH:
//         width = commitment <= 20 ? 44 : 33.333333;
//         break;
//       case TIMELINE_AREAS.REMAINING:
//         width =
//           100 -
//           getWidth(TIMELINE_AREAS.EXPLORATION, commitment) -
//           getWidth(TIMELINE_AREAS.JOB_SEARCH, commitment);
//         break;
//       default:
//         break;
//     }
//   }

//   return width;
// };

// function getColSpan() {}

// // Months array for reference
// const months = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// // Returns months only
// const getMonths = (joinedOn) => {
//   let m = [];
//   let joined = joinedOn.month() + 1;

//   if (joined < 2) {
//     m = [months[months.length - 1], ...months.slice(joined - 1, joined + 6)];
//   } else if (joined < 6) {
//     m = months.slice(joined - 2, joined + 7);
//   } else {
//     m = months.slice(joined - 2);
//     m = [...m, ...months.slice(0, 9 - m.length)];
//   }

//   return m;
// };

// const getMonthsWithYears = (joinedOn) => {
//   const joinedMonth = joinedOn.month(); // 0-based index for months
//   const joinedYear = joinedOn.year();

//   let timeline = [];
//   let currentYear = joinedYear;

//   // Loop through 9 months starting from the joined month
//   for (let i = -1; i < 8; i++) {
//     let monthIndex = joinedMonth + i;

//     // Adjust for negative or overflowing month indexes
//     if (monthIndex < 0) {
//       monthIndex += 12;
//       currentYear -= 1; // If we wrap back to previous year
//     } else if (monthIndex >= 12) {
//       monthIndex -= 12;
//       currentYear += 1; // If we wrap forward to next year
//     }

//     timeline.push(`${months[monthIndex]} ${currentYear}`);
//   }

//   return timeline;
// };


// const monthsBeforeToday = (month, joinedOn) => {
//   return getMonths(joinedOn).indexOf(months[month]);
// };

// export { TIMELINE_AREAS, getWidth, getColSpan, getMonths, getMonthsWithYears, monthsBeforeToday };
